import React__default from 'react';
import { ProductDetailDisclaimer } from './ProductDetailDisclaimer.js';
import { useCmsData } from '../../../context/CmsContext.js';

const ProductDetailDisclaimerContainer = ({ className  })=>{
    const { disclaimer  } = useCmsData();
    if (!disclaimer) {
        return null;
    }
    return /*#__PURE__*/ React__default.createElement(ProductDetailDisclaimer, {
        className: className,
        disclaimer: disclaimer
    });
};

export { ProductDetailDisclaimerContainer };
//# sourceMappingURL=ProductDetailDisclaimerContainer.js.map
